// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailInfo.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var EventUtils = require('EventUtils');
  var connect = require('share/enhancers/Izenda.Connect');

  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var withState = require('recompose').withState;

  var EmailConfigInput = require('./Izenda.EmailConfigInput');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  const { curry } = require('lodash/fp');

  var action = compose(
    withState('show', 'setShow', true),
    withHandlers({
      onChange: curry(handleChangeConfig),
      toggleShow: curry(toggleShow)
    })
  );

  function handleChangeConfig(props, dataKey, value) {
    props.config.setValueByKey(dataKey, value);
  }

  function toggleShow(props, _) {
    props.setShow(!props.show);
  }

  var EmailInfo = function(props) {
    var config = props.config;
    var localization = props.localization;
    var show = props.show;
    var collapseIcon = show ? 'icon-triangle-down' : 'icon-triangle-right';
    var titleIcon = show ? localization.getText('COMMON_LABEL_COLLAPSE') : localization.getText('COMMON_LABEL_EXPAND');

    return (
      <div>
        <div className="u-bgGray u_paddingAll">
          <a onClick={props.toggleShow}>
            <span title={titleIcon} className={collapseIcon} />
          </a>
          <span>{localization.getText('EMAIL_LABEL_EMAIL_INFO')}</span>
        </div>
        {show && (
          <GridLayout className="u-bgWhite u_paddingAll">
            <EmailConfigInput
              title={localization.getText('EMAIL_LABEL_DISPLAY_NAME')}
              value={config.displayName}
              dataKey="displayName"
              onChange={props.onChange}
            />
            <EmailConfigInput
              title={localization.getText('EMAIL_LABEL_EMAIL_FROM_ADDRESS')}
              value={config.emailFromAddress}
              dataKey="emailFromAddress"
              isRequired
              onChange={props.onChange}
            />
          </GridLayout>
        )}
      </div>
    );
  };

  module.exports = connect(action)(EmailInfo);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Email/Izenda.EmailInfo.jsx